<template lang="pug">
  .contacts-list
    .contacts-list__item.contact
      .contact__icon
        img(src="@/assets/images/icons/contact-geo.svg" alt="Адрес")
      .contact__link
        a(href="https://yandex.ru/maps/-/CCe07Ql-" target="_blank").link ул. Сафьян, д.5, Казань, Респ. Татарстан, 420021
    .contacts-list__item.contact
      .contact__icon
        img(src="@/assets/images/icons/contact-web.svg" alt="Сайт")
      .contact__link
        a(href="http://minmol.tatarstan.ru").link minmol.tatarstan.ru
    .contacts-list__item.contact
      .contact__icon
        img(src="@/assets/images/icons/contact-phone.svg" alt="Телефон")
      .contact__link
        a(href="tel:8-843-222-9150").link 8 (843) 222-91-50
    .contacts-list__item.contact
      .contact__icon
        img(src="@/assets/images/icons/contact-email.svg" alt="Почта")
      .contact__link
        a(href="mailto:mdmrt@tatar.ru").link mdmrt@tatar.ru
</template>

<script>
export default {
  name: "contacts-list",
};
</script>
